import {
  Boutique,
  Buyer,
  Price,
  StoredObject,
  TypedFileObject,
} from "@/features/types";
import { DateTimeString } from "@/features/ui/utils/date-utils";

export type TransportationStatus =
  | "WAYBILL_ISSUED"
  | "FLIGHT_DEPARTED"
  | "FLIGHT_ARRIVED"
  | "CUSTOMS_DECLARED"
  | "CUSTOMS_WAREHOUSING"
  | "CUSTOMS_CLEARED"
  | "CUSTOMS_EXPORT_DECLARED"
  // | "DOMESTIC_RECEIVED"
  | "DOMESTIC_DISPATCHING"
  // | "DOMESTIC_DISPATCHED"
  | "DOMESTIC_SHIPPING"
  | "DOMESTIC_SHIPPING_COMPLETED";

export const TransportationStatuses: TransportationStatus[] = [
  "WAYBILL_ISSUED",
  "FLIGHT_DEPARTED",
  "FLIGHT_ARRIVED",
  "CUSTOMS_DECLARED",
  "CUSTOMS_WAREHOUSING",
  "CUSTOMS_CLEARED",
  "CUSTOMS_EXPORT_DECLARED",
  // "DOMESTIC_RECEIVED",
  "DOMESTIC_DISPATCHING",
  // "DOMESTIC_DISPATCHED",
  "DOMESTIC_SHIPPING",
  "DOMESTIC_SHIPPING_COMPLETED",
];

export interface Transportation {
  id: number;
  name: string;
  status: TransportationStatus;
  shippedFromList: Boutique[];
  shippedThrough: Boutique | null;
  shippedTo: Buyer;
  shippedToAddress: string;
  shippedToRecipientName: string;
  shippedToContact: string;
  forwarderInvoiceNumbers: string[];

  mawbNumber: string | null;
  houseBlNumbers: string[];

  domesticCarrierName: string | null;
  domesticTrackingNumber: string | null;

  flightNumber: string;
  flightDepartureAirport: string;
  flightArrivalAirport: string;
  flightEtd: DateTimeString;
  flightEta: DateTimeString;
  flightAtd: DateTimeString;
  flightAta: DateTimeString;
  finalEta: Date | null;

  cost: number;
  details: TransportationDetail[];
  files: StoredObject[];

  proformaInvoices: { id: number; name: string }[];

  transportationPayment: TransportationPayment | null;

  createdAt: Date;
  updatedAt: Date;
}

export interface TransportationDetail {
  status: TransportationStatus;
  createdAt: Date | null;
}

export interface TransportationPayment {
  id: number;
  amount: Price | number;
  issuedOn: string | null;
  file: TypedFileObject;
  isRemitted: boolean;
  remittedOn: string | null;
}
